import {
  Row,
  Col,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
  ModalFooter,
  Modal,
} from "reactstrap";
import DataTable from "../../../Core/DataTable";
import NotificationAlert from "react-notification-alert";
import Notify from "../../../../lib/Utils/Alert";
import Select from "react-select";
import PurchaseOrder from "../../../../lib/Core/Backend/Controllers/PurchaseOrder";
import Purchaser from "../../../../lib/Core/Backend/Controllers/Purchaser";
import Brand from "lib/Core/Backend/Controllers/Brand";
import { useRef, useEffect, useState, useMemo,useCallback } from "react";
import useCatalogs from "../../../../hooks/useCatalogs";
import useSession from "hooks/useSession";
import { SwipeableDrawer } from "@mui/material";
import HistorySKUDetails from "./HistorySKUDetails";
import Utils from "lib/Utils/Utils";
import Spinner from 'react-bootstrap/Spinner';

const ModalHistorySKU = ({
  isOpen,
  toggle,
}) => {
  const {currencies} = useCatalogs()
  const {token} = useSession()
  const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const dataTableRef = useRef(null);
  const alert = useRef(null);
  const startDateInput = useRef();
  const endDateInput = useRef();
  const [dataTableData, setDataTableData] = useState({
    purchaseOrderResponse: [],
  });
  const [orderDetail, setOrderDetail] = useState([]);
  const [skuSearch, setSkuSearch] = useState('')
  const [cardReferenceSearch, setCardReferenceSearch] = useState('')
  const [skuName, setSkuName] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [brandvalue,setBrandValue] = useState();
  const [orderNoValue, setOrderNoValue] = useState();
  const [showValue,setShowValue] = useState([])
  const [showCustomValue ,setShowCustomValue] = useState([])
  const [showFullfillment,setShowFullfillment] = useState([])
 
  const [fulfillmentValue, setFulfillmentValue] = useState([]);
  const [customerValue, setCustomerValue] = useState();
  const [brandOption,setBrandOption] = useState([])
  const [customerOption,setCustomerOption] = useState([])
  const [searchData,setSearchData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [dataTableShow,setDataTableShow] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [loader,setLoader] = useState(false)
  const toggleDrawer = () => setOpenDrawer(!openDrawer);
  const brandsCtl = useMemo(() => new Brand(token),[token]);


  
useEffect(() => {
 if (searchData.length > 0) {
    const dynamicColumns = extractDynamicColumns(searchData);
    const transformedData = transformData(searchData, dynamicColumns);
    setTableColumns(generateHeader(dynamicColumns));
    setTableData(transformedData);
  }
}, [searchData.length, trigger,startDate,endDate,brandvalue,orderNoValue,customerValue,fulfillmentValue]);

useEffect(() => {
  if (dataTableRef.current) {
    const dataTableInstance = dataTableRef.current.dataTable;
    dataTableInstance.clear();
    dataTableInstance.rows.add(tableData);
    dataTableInstance.draw();
  }
}, [tableData]);

const extractDynamicColumns = (data) => {
const dates = new Set();
  data.forEach(item => {
    Object.keys(item.historic).forEach(date => {
      dates.add(date);
    });
  });
  return Array.from(dates).sort();
};
 




const generateHeader = dynamicColumns => {
  return [
    { title: "Brand", data: "brandName", sortable: true },
    { title: "Value", data: "amount", sortable: true },
    ...dynamicColumns.map(date => ({ title: date, data: date, sortable: true })),
    { title: "Total Quantity", data: "totalQuantity", sortable: true },
    { title: "Stock", data: "totalStock", sortable: true },
  ];
};

const transformData = (data, dynamicColumns) => {
return data.map(item => {
    const transformedItem = {
      brandName: item.brandName,
      amount: item.amount,
      totalQuantity: item.totalQuantity,
      totalStock: item.totalStock
    };
    dynamicColumns.forEach(date => {
      transformedItem[date] = item.historic[date] || 0.0;
    });
    return transformedItem;
  });
};

// const transformedData = transformData(searchData, dynamicColumns);


const soldby = [
  {value:1,label:"API"},
  {value:2,label:"NRT"},
  {value:3,label:"API+Inventory"},
]
  

  

  const prepareDetails = (row) => {
    let data = row.data();
    let processedData = {
      totalAmount: data.totalAmount,
      purchaseOrderDetails: data.purchaseOrderDetail.map(detail => ({
        date: new Date(detail.createdAt).toLocaleDateString(),
        productName: detail.cardTypeName,
        supplierName: data.supplierName,
        faceValue: data.subtotal,
        totalQuantity: detail.quantity,
        fee: detail.fee,
        discount: detail.discount,
        totalAmount: detail.total
      }))
    }
    setOrderDetail(processedData);
    toggleDrawer();
  };

  const handleSearchClick = () => {
    setLoader(true)
    const body = {};
  if (customerValue) {
      body.purchaser = customerValue;
    }
  if (brandvalue) {
      body.brand = brandvalue;
    }
  
   if (fulfillmentValue.length > 0) {
      body.fulfillment = fulfillmentValue;
    }
  if (startDate || endDate) {
      body.date = {};
      if (startDate) {
        body.date.from = startDate;
      }
      if (endDate) {
        body.date.to = endDate;
      }
    }
  
if(body){
  purchaseOrderCtl.getHistory(body,(data)=>{
    if(data && !data.error){
      setDataTableShow(true)
       setSearchData(data?.data);
       setShowFullfillment([]);
       setShowValue([]);
       setShowCustomValue([])
       setCustomerValue(null);
       setBrandValue(null);
       setOrderNoValue('');
       setFulfillmentValue([])
       setstartDate(null)
       setendDate(null)
       setTrigger(prev => !prev);
       setLoader(false)
    }else{
      Notify(alert,"danger",data?.errorMessage ?? data?.error)
      setTimeout(() => {
        setLoader(false) 
      }, 2000);
    }

  })
}
 

  }

  const drawHistoricalInformation = ({ data, purchaserData }) => {
    if (data && !data.error) {
      data.forEach(item => {
        let hasPurchaserDetail = false
        let supplierDetail = []
        let purchaser = item.purchaseSourceTypeId === 2 ? purchaserData.find(purchaser => purchaser.id === item.purchaseSourceId) : null;
        let itemCurrency = currencies.find(currency => currency.id === item.currencyId)
        const currencyFormat = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: itemCurrency?.code ?? 'USD'
        })
        if (item.purchaseOrderDetail.length > 0) {
          item.purchaseOrderDetail.forEach(orderDetail => {
            if (orderDetail.detailProcessing.length > 0){
              supplierDetail = orderDetail.detailProcessing[0]
              hasPurchaserDetail = true
            }
          })
        }

        item.purchaseOrderDetail[0].amount = currencyFormat.format(item.purchaseOrderDetail[0].amount)
        item.purchaseOrderDetail[0].discount = Utils.percentFormat(item.purchaseOrderDetail[0].discount/100)
        item.purchaseOrderDetail[0].fee = currencyFormat.format(item.purchaseOrderDetail[0].fee)


        item.supplierName = hasPurchaserDetail > 0 ? supplierDetail.supplierName : ''
        item.supplierFee = hasPurchaserDetail > 0 ? currencyFormat.format(supplierDetail.supplierFee) : '$0.00'
        item.supplierDiscount = hasPurchaserDetail > 0 ? Utils.percentFormat(supplierDetail.supplierDiscount/100) : '0%'
        item.itemQtyNo = hasPurchaserDetail > 0 ? supplierDetail.itemQtyNo : 0
        item.subtotal = currencyFormat.format(item.subtotal)
        item.purchaser = purchaser ? purchaser.name : 'N.A.'
        
      })
      
      setDataTableData(data);
      setSkuName(skuSearch);
    } else if (data.errorMessage) {
      setSkuSearch("");
      Notify(alert, "danger", data.errorMessage);
    } else {
      Notify(alert, "danger", data.error);
    }
  };

  const toggleClose = () => {
    setTableData([])
    setSearchData([])
    setTableColumns([])
    toggle(); 
    setSkuName(''); 
    setDataTableData({})
  }
  const handleDate = (e) => {
    if(orderNoValue?.trim().length > 0 ){
      setstartDate(null);
      setendDate(null);
      startDateInput.current.value = ''
      endDateInput.current.value = ''
      Notify(alert,"danger","You can not select other option as you provided order no");
      return;
    }
    if(e.target.id === 'startDate'){
      setstartDate(e.target.value)
      setendDate(null)
      endDateInput.current.value = '';
      endDateInput.current.select();
    } else {
      if(!startDate){
        Notify(alert, 'danger', 'First Select a Start date');
        endDateInput.current.value = '';
        startDateInput.current.focus();
        return;
      }
      setendDate(e.target.value)
    }
  }

  useEffect(()=>{
    brandsCtl.all(data=>{
      if(data && !data.error){
        const brandData = data.result.map((item)=>({
         value:item.id,
         label:item.name
        }))

      setBrandOption(brandData)
      }
    })
  },[])

  useEffect(()=>{
    purchaserCtl.all(data=>{
      if(data && !data.error){
      const customerData = data.map((item)=>({
          value:item.id,
          label:item.name
        }))

      setCustomerOption(customerData)
      }
    })
  },[])

  useEffect(() => {
    dataTableRef.current &&
      dataTableRef.current.dataTable
        .clear()
        .rows.add(dataTableData)
        .draw();
  }, [dataTableData]);

  const handleFullfillment =(options)=>{
    if(orderNoValue?.trim().length >  0 ){
      Notify(alert,"danger","You can not select other option as you provided order no");
      return;
     }else{
      const value = options.map(item => item.label)
      setFulfillmentValue(value)
      setShowFullfillment(options)
    }
    
  }
const handleOrderNo = (e)=>{
  const value = e.target.value;
  setOrderNoValue(value);

}
const handleCustomer = (select)=>{
  if(orderNoValue?.trim().length >  0 ){
    Notify(alert,"danger","You can not select other option as you provided order no");
    return;
  }else{
    setShowCustomValue(select)
    const value = select?.value;
    setCustomerValue(value)
  }
  

}
const handleBrand = (selectOption) =>{
  if(orderNoValue?.trim().length >  0 ){
    Notify(alert,"danger","You can not select other option as you provided order no");
      return;
  }else{
    const value = selectOption?.value;
    setShowValue(selectOption)
    setBrandValue(value)
  }
  
}

const downloadCsv = useCallback(() => {
  if (!searchData || searchData.length === 0) {
      console.error("No data available for CSV download.");
      return;
  }

  let csvRows = [];
  // Extract unique date columns
  let dateColumns = new Set();
  searchData?.forEach(card => {
      Object.keys(card.historic).forEach(date => {
          dateColumns.add(date);
      });
  });
  dateColumns = Array.from(dateColumns).sort();

  // Create CSV header
  csvRows.push(`Brand,Value,${dateColumns.join(',')},Total Quantity,Total Stock`);

  // Add data rows
  searchData?.forEach(card => {
      let row = [
          card.brandName,
          card.amount,
      ];

      // Add values for dynamic date columns
      dateColumns?.forEach(date => {
          row.push(card.historic && card.historic[date] !== undefined ? card.historic[date] : 'Not Available');
      });

      row.push(card.totalQuantity);
      row.push(card.totalStock);

      csvRows.push(row.join(','));
  });

  let csvContent = csvRows.join("\n");

  const element = document.createElement("a");
  const file = new Blob([csvContent], { type: 'text/plain' });
  element.href = URL.createObjectURL(file);
  element.download = `Available_stock.csv`;
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
}, [searchData]);



  return (
    <>
      <NotificationAlert ref={alert} />
      <Modal isOpen={isOpen} toggle={toggleClose} size="xl" backdrop="static">
        <ModalHeader toggle={toggleClose} className="custom_header_colourTwo">
          View historical data: <b>{skuName}</b>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg={4}>
              <FormGroup>
                <Label for="mainPhone">Brand</Label>
                <Select 
                options={brandOption} 
                value={orderNoValue?.trim().length > 0 ? null : showValue}
                isClearable={true}
                onChange={handleBrand}
                placeholder="Select Brand"
              />
              </FormGroup>
            </Col>
            <Col lg={4}>
              <FormGroup>
                
                <Label for="mainPhone">Customer</Label>
                <Select 
                options={customerOption} 
                value={orderNoValue?.trim().length > 0 ? null : showCustomValue}
                isClearable={true}
                onChange={handleCustomer}
                placeholder="Select Customer"
              />
              </FormGroup>
            </Col>
            <Col lg={3} className="align-self-end">
            {loader ? 
            <Button
            initial={{ x: "-500%", opacity: 0 }}
            animate={{
              x: 0,
              opacity: 1,
              transition: { delay: 0.4, duration: 0.5 },
            }}
            
            disabled
            
            className="loader_size btn btn-primaryTwo"
          >
            <i className="fas fa-search" /> Search
                       <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        style={{marginLeft:"4px"}}
                        />
          </Button>
          :
              <Button
                initial={{ x: "-500%", opacity: 0 }}
                animate={{
                  x: 0,
                  opacity: 1,
                  transition: { delay: 0.4, duration: 0.5 },
                }}
               className="btn btn-primaryTwo"
                onClick={handleSearchClick}
              >
                <i className="fas fa-search" /> Search
              </Button>
          }
              
            </Col>
            <Col lg={4}>
            <FormGroup>
                
                <Label for="mainPhone">Order No:</Label>
                <Input
                type="text" 
                // options={currencyOptionThird} 
                onChange={handleOrderNo}
                placeholder="Select Order No"
              />
              </FormGroup>
            </Col>
            <Col lg={4}>
            <FormGroup>
                
                <Label for="mainPhone">Fullfillment Type</Label>
                <Select 
                options={soldby} 
                isMulti={true}
                value={orderNoValue?.trim().length > 0 ? null : showFullfillment}
                isClearable={true}
                onChange={handleFullfillment}
                placeholder="Select Fullfillment type"
              />
              </FormGroup>
            </Col>
            <Col lg={3} className="align-self-end">
            {searchData.length > 0 ? 
            <Button onClick={downloadCsv}  className="btn btn-primaryTwo">Download File</Button>
            : ""
            }
            
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for='startDate' >Start date</Label>
                <Input type='date' id='startDate' pattern='\d{4}-\d{2}-\d{2}' innerRef={startDateInput} onChange={handleDate}/>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for='endDate'>End date</Label>
                <Input type='date' id='endDate' pattern='\d{4}-\d{2}-\d{2}' innerRef={endDateInput} onChange={handleDate} min={startDate ? startDate : ''}/>
              </FormGroup>
            </Col>
          </Row>
          
          <Row>
            <Col md="12 mt-5">
            {tableColumns.length > 0 && searchData.length > 0 ?
              <DataTable
                ref={dataTableRef}
                data={tableData}
                columns={tableColumns}
                responsive= {true}
                options={{ dom: "tip", order: [[0, 'desc']] }}
                
              />
              : (
                searchData.length === 0 && dataTableShow === true ? 
                <p style={{textAlign:"center", fontSize:"17px", fontWeight:"600"}}>No Data available</p>
                : ""
              )
              
              
            }
              
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="flex-nowrap">
          <Col md={6} className="justify-content-end text-right">
            <Button
              type="submit"
              className="mr-3"
              color="secondary"
              onClick={toggleClose}
            >
              Close
            </Button>
          </Col>
        </ModalFooter>
      </Modal>
      <SwipeableDrawer
        anchor="right"
        open={openDrawer}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
      >
        <div style={{ width: "70vw" }}>
          <HistorySKUDetails data={orderDetail} />
        </div>
      </SwipeableDrawer>
    </>
  );
};

export default ModalHistorySKU;
